import "core-js/modules/es6.array.find";
import store from '@/store';
import { getCurrentBizCode } from "./routeHelper";

/**
 * 获取当前业务信息
 * 使用统一的业务代码获取逻辑
 * @returns {Object} 包含业务ID和业务代码的对象
 */
export function getCurrentBiz() {
  // 使用统一的业务代码获取函数
  var currBizCode = getCurrentBizCode();
  var currBiz = store.state.profile.currBiz;

  // 如果业务代码与 Store 中的不同，则查找对应的业务信息
  if (currBizCode !== store.state.profile.currBizCode) {
    var bizList = store.state.profile.bizList;
    var selectedBiz = bizList.find(function (biz) {
      return biz.code === currBizCode;
    });
    if (selectedBiz) {
      currBiz = selectedBiz.id;
    }
  }
  return {
    bizId: currBiz,
    bizCode: currBizCode
  };
}